module.exports = __webpack_public_path__ + "img/advertise_common2.7bd88080.png";